import { render, staticRenderFns } from "./retailAccountList.vue?vue&type=template&id=e620bc00"
import script from "./retailAccountList.vue?vue&type=script&lang=js"
export * from "./retailAccountList.vue?vue&type=script&lang=js"
import style0 from "./retailAccountList.vue?vue&type=style&index=0&id=e620bc00&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports